module.exports = __webpack_public_path__ + "media/heavyhit.e5770086.wav";